import React from 'react'
import { Bar } from 'react-chartjs-2'

const VerticalBarGraph = (props) => {
    let { title, x, y, secondTitle, a, width, height } = props

    const dataSets = {
        labels: x,
        datasets: [
            {
                label: title,
                fill: false,
                lineTension: 0.1,
                backgroundColor: 'rgba(16, 185, 129, 0.7)',
                borderColor: '#10B981',
                borderWidth: 1,
                borderRadius: 4,
                borderCapStyle: 'butt',
                borderDash: [],
                borderDashOffset: 0.0,
                borderJoinStyle: 'miter',
                pointBorderColor: '#10B981',
                pointBackgroundColor: '#fff',
                pointBorderWidth: 1,
                pointHoverRadius: 5,
                pointHoverBackgroundColor: '#10B981',
                pointHoverBorderColor: '#059669',
                pointHoverBorderWidth: 2,
                pointRadius: 5,
                pointHitRadius: 10,
                data: y,
                datalabels: {
                    display: true,
                    color: '#475569',
                    anchor: 'end',
                    align: 'top',
                    font: {
                        weight: '600',
                        size: 11,
                        family: 'Inter, sans-serif'
                    }
                }
            },
            {
                label: secondTitle,
                fill: false,
                lineTension: 0.1,
                backgroundColor: 'rgba(59, 130, 246, 0.7)',
                borderColor: '#3B82F6',
                borderWidth: 1,
                borderRadius: 4,
                borderJoinStyle: 'miter',
                pointBorderColor: '#3B82F6',
                pointBackgroundColor: '#fff',
                pointBorderWidth: 3,
                pointHoverRadius: 5,
                pointHoverBackgroundColor: '#3B82F6',
                pointHoverBorderColor: '#2563EB',
                pointHoverBorderWidth: 2,
                data: a,
                datalabels: {
                    display: true,
                    color: '#475569',
                    anchor: 'end',
                    align: 'top',
                    font: {
                        weight: '600',
                        size: 11,
                        family: 'Inter, sans-serif'
                    }
                }
            }
        ]
    };

    var options = {
        scales: {
            yAxes: [{
                stacked: false,
                ticks: {
                    beginAtZero: true,
                    min: 0,
                    fontFamily: 'Inter, sans-serif',
                    fontSize: 11,
                    fontColor: '#94A3B8'
                },
                gridLines: {
                    color: '#F1F5F9',
                    zeroLineColor: '#E2E8F0',
                    drawBorder: false
                }
            }],
            xAxes: [{
                ticks: {
                    fontFamily: 'Inter, sans-serif',
                    fontSize: 11,
                    fontColor: '#94A3B8'
                },
                gridLines: {
                    display: false
                }
            }]
        },
        legend: {
            position: 'top',
            align: 'end',
            display: true,
            labels: {
                boxWidth: 12,
                fontColor: '#475569',
                fontFamily: 'Inter, sans-serif',
                fontSize: 12,
                padding: 16,
                usePointStyle: true,
                pointStyle: 'circle'
            }
        },
        layout:{
            padding:{
                top: 25,
                right: 10
            }
        },
        responsive: true,
        tooltips: {
            backgroundColor: '#0F172A',
            titleFontFamily: 'Inter, sans-serif',
            titleFontSize: 12,
            bodyFontFamily: 'Inter, sans-serif',
            bodyFontSize: 12,
            cornerRadius: 8,
            xPadding: 12,
            yPadding: 10,
            caretSize: 6,
            displayColors: true
        }
    };

    return (
        <Bar width={width}
            height={height}
            data={dataSets}
            options={options}
        />
    )

}
export default VerticalBarGraph
